// Basic
import PropTypes from 'prop-types';
// Components
import { Card, CardHeader, CardContent } from '../../ui/card';
import IconTooltip from '../iconTooltip/IconTooltip';
import Entity from '../entity/Entity';
// Common
import ICONS from '@/common-utils/enums/icons';

/**
 * @param {Object} props
 * @param {JSX} props.children
 * @param {string} props.title
 * @param {string} props.tooltipEntity
 * @param {Object} props.refreshAction
 * @param {string} props.description
 * @param {string} props.namespace
 * @returns {JSX} ChartCard
 */
function ChartCard({ children, title, tooltipEntity = '', refreshAction = null, description = '', namespace = '' }) {

    return (
        <Card className='border border-gray-300 min-h-[280px]'>
            <CardHeader className='flex flex-row justify-between items-center px-2 py-2'>
                <div className='flex items-center gap-1'>
                    <div className='flex flex-col items-start gap-1'>
                        <div className='flex items-center gap-1'>
                            <Entity
                                entity={title}
                                namespace={namespace}
                                className='text-md font-semibold'
                            />
                            <IconTooltip icon={ICONS.HELP} tooltipEntity={tooltipEntity} namespace={namespace} />
                        </div>
                        {description && (
                            <Entity
                                entity={description}
                                namespace={namespace}
                                className='text-sm text-muted-foreground'
                            />
                        )}
                    </div>
                </div>
                {refreshAction && (
                    <Button
                        variant='ghostNoBorder'
                        icon={ICONS.REFRESH}
                        onClick={refreshAction.onClick}
                    />
                )}
            </CardHeader>
            <CardContent className='flex-1 pl-4 pr-0 pb-2 pt-0'>
                {children}
            </CardContent>
        </Card >
    );
}

ChartCard.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    tooltipEntity: PropTypes.string,
    refreshAction: PropTypes.func,
    description: PropTypes.string,
    namespace: PropTypes.string
};

export default ChartCard;